export const getSelectedDate = state => state.date.selectedDate;
